import BaseComponent from 'foundation/base-component';
import gtm from '../../../general/js/gtm';

export default class GtmTriggerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.category = null;
        this.action = null;
        this.label = null;
        this.init();
    }

    init() {
        this.addListener(this.element, 'click', this.onClick);
    }

    onClick = () => {
        gtm.push(this.getCategory(), this.getAction(), this.getLabel());
    }


    getCategory() {
        if (this.category === null) {
            this.category = this.getAttribute(this.element, 'category');
        }
        return this.category;
    }

    getAction() {
        if (this.action === null) {
            this.action = this.getAttribute(this.element, 'action');
        }
        return this.action;
    }

    getLabel() {
        if (this.label === null) {
            this.label = this.getAttribute(this.element, 'label');
        }
        return this.label;
    }
}
